import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Product, Price } from '@models/product';
import { UserService } from '@services/user.service';

@Pipe({
  name: 'getPrices',
})
export class GetPricesPipe implements PipeTransform {
  constructor(private userServ: UserService) {}

  /**
   * Méthode qui retourne les ou le prices valide pour un produit
   * vérifie les price en fonciton du cover du produit
   */
  transform(product: Product, ...args: any[]): any {
    //premier tris en fonction des dates
    let prices: Price[] = product.prices.filter((price) => {
      let start: Date = new Date(price.start);
      let end: Date = new Date(price.end);
      let now: Date = new Date();
      if (!price.group || this.userServ.user.groupe == price.group) {
        if (price.start == null && price.end == null) return true;
        if (
          price.start != null &&
          price.end == null &&
          start.getTime() <= now.getTime()
        )
          return true;
        if (start.getTime() <= now.getTime() && end.getTime() >= now.getTime())
          return true;
      }
      return false;
    });

    //deuxieme tris en fonction des qte (=> si plusieurs prix pour la même qte on ne garde en priorité le prix avec les date)
    //=> si un prix "groupe" (ex: vente privée) existe pour cette qte, il est prioritaire sur le prix public générique,
    //   car il a déjà été validé comme éligible pour l'utilisateur courant au tri précédent.
    prices = prices.filter((price) => {
      let sameQte = prices.filter((p) => p.qte == price.qte);
      let hasGroupPrice = sameQte.some((p) => !!p.group);

      if (hasGroupPrice) return !!price.group;

      let occurs = sameQte.filter((occur) => occur.ident != price.ident);
      return occurs.length == 0 || price.start != null;
    });

    if (product.cover)
      prices = prices.filter((price) => price.img == product.cover);

    if (args[0] !== null && args[0] !== undefined) {
      if (args[0] < prices.length) return prices[args[0]];
      else return null;
    }

    return prices;
  }
}

@Pipe({
  name: 'formatPrice',
})
export class FormatPricePipe implements PipeTransform {
  transform(price: any, discounted: any = false, ...args: any[]) {
    if (typeof price != 'number') {
      if (price) {
        if (discounted && price.discounted)
          return formatNumber(price.discounted, 'fr', '1.2-2');
        else return formatNumber(price.prix, 'fr', '1.2-2');
      } else return null;
    }
    return formatNumber(price, 'fr', '1.2-2');
  }
}
